import { Button } from '@library/components/buttons';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { classNames } from '@library/utils';

export interface CloseIconButtonProps {
  className?: string;
  handleOnClick: () => void;
}

export const CloseIconButton = ({
  className = '',
  handleOnClick
}: CloseIconButtonProps) => {
  return (
    <Button
      className={classNames('-m-1.5 flex-none p-1.5', className)}
      data-testid="CloseIconButton"
      title="CloseIconButton"
      onClick={handleOnClick}
      type="button"
    >
      <span className="sr-only">Dismiss</span>
      <XMarkIcon
        aria-hidden="true"
        className="text-soClean-100 size-5"
        data-testid="XMarkIcon"
      />
    </Button>
  );
};
